import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface PhoneFrameProps {
    children: ReactNode
    className?: string
}

/** A minimal phone body with a camera island. The screen keeps a 9:19.5 ratio. */
export const PhoneFrame: FC<PhoneFrameProps> = ({ children, className }): ReactNode => (
    <div className={cn('phone-frame', className)}>
        <div className='phone-screen'>
            {children}
            <span className='phone-island' aria-hidden='true' />
        </div>
    </div>
)
